module.exports = __webpack_public_path__ + "img/reverse-normal.2cfd182f.svg";